export default "__VITE_ASSET__D$IYgnfJ__"